const PortionSizes = () => import("../portionSizes/views/PortionSizes.vue");
const PortionSizeEdit = () => import("../portionSizes/views/PortionSizeEdit.vue");

const route = "/portionSizes";

export default [
  {
    path: route,
    name: "portionSizes.list",
    component: PortionSizes,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "portionSizes.create",
    component: PortionSizeEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:portionSizeId/edit`,
    name: "portionSizes.edit",
    component: PortionSizeEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
